import { StyledButton, StyledButtonWrapper, StyledCTAMenuWrapper } from './CTAMenu.styles';

interface CTAMenuProps {
  ctaMenu: Queries.LinkFragment[];
}

const CTAMenu = ({ ctaMenu }: CTAMenuProps) => {
  if (ctaMenu.length === 0) {
    return null;
  }

  return (
    <StyledCTAMenuWrapper>
      <StyledButtonWrapper>
        {ctaMenu.map((cta, index: number) => {
          const isSecondCTAButton = Boolean(index > 0);
          return (
            <StyledButton
              {...cta}
              className="cta-menu-link"
              isSecondCTAButton={isSecondCTAButton}
              key={cta.system.id}
            />
          );
        })}
      </StyledButtonWrapper>
    </StyledCTAMenuWrapper>
  );
};

export default CTAMenu;
